export function isError(err) {
    return err instanceof Error && "tag" in err && typeof err.tag === "string";
}
